<template>
    <span>
        <i class="fas fa-check text-primary" v-if="condition"></i>
        <i v-else class=" text-danger fas fa-times-circle"></i>
    </span>
</template>

<script>
    export default {
        props: ['condition']
    }
</script>